
import { BillingStatus, InviteStatus, InvoiceStatus } from "@/types/constants";

// Default values
export const DEFAULT_BILLING_STATUS: BillingStatus = "current";
export const DEFAULT_INVITE_STATUS: InviteStatus = "pending";
export const DEFAULT_INVOICE_STATUS: InvoiceStatus = "unpaid";

// Type exports
export type { BillingStatus, InviteStatus, InvoiceStatus };

// Type mapping functions
export const mapToBillingStatus = (status: string | null | undefined): BillingStatus => {
  if (!status) return DEFAULT_BILLING_STATUS;
  
  switch (status) {
    case "current":
    case "overdue":
    case "inactive":
      return status as BillingStatus;
    default:
      return DEFAULT_BILLING_STATUS;
  }
};

export const mapToInviteStatus = (status: string | null | undefined): InviteStatus => {
  if (!status) return DEFAULT_INVITE_STATUS;
  
  switch (status) {
    case "pending":
    case "sent":
    case "accepted":
    case "declined":
    case "expired":
      return status as InviteStatus;
    default:
      return DEFAULT_INVITE_STATUS;
  }
};

export const mapToInvoiceStatus = (status: string | null | undefined): InvoiceStatus => {
  if (!status) return DEFAULT_INVOICE_STATUS;
  
  switch (status) {
    case "draft":
    case "unpaid":
    case "partial":
    case "paid":
    case "overdue":
    case "void":
      return status as InvoiceStatus;
    default:
      return DEFAULT_INVOICE_STATUS;
  }
};
